<template>
      <div>
        <div id="myline" class="line">

        </div>

        <section class="first_news">
            <div id="together1_text">
                <div class="center">
                    <p class="text1">1 October 2020 is the day of the initiative from our team colleagues of AI Department Lviv Polytechnic National University and Danylo Halytsky Lviv National Medical University, that had transferred to the Department of Health of Lviv
                        Regional State Administration 9600 ELISA test systems and support materials for conducting laboratory tests at the specialized laboratories of Lviv Region for identifying COVID 19, which were purchased with the funding by the Center
                        European Initiative (CEI) within the Project Stop COVID19. The total contribution is 10,000 EUR.</p>
                </div>
                <div class="break">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
                <div id="center_ul">
                    <ul class="text1">
                        <li><a id="ul_url" href="https://www.facebook.com/Stop-Covid19-100246368451312/">Facebook page of the project "STOP COVID-19"</a></li>
                        <br>
                        <li><a id="ul_url" href="https://t.me/COVID19_Ukraine">Telegram channel</a></li>
                    </ul>
                </div>
            </div>
            <div id="img_box1">
                <img id='together1' src="../../assets/together1.jpg" alt="">
            </div>
            <div id="img_box2">
                <img id='together2' src="../../assets/together2.jpg" alt="">
            </div>

        </section>
        </div>
</template>

<script>
export default {
  name: 'Three_content',
    
    
    
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.first_news {
  padding-top: 120px;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 10% (minmax(10px, 1fr))[10] 10%;
      grid-template-columns: 10% repeat(10, minmax(10px, 1fr)) 10%;
  -ms-grid-rows: 2fr 2fr;
      grid-template-rows: 2fr 2fr;
  padding-bottom: 60px;
}

#img_box1 {
  -ms-grid-row: 1;
  -ms-grid-row-span: 1;
  grid-row: 1/2;
  -ms-grid-column: 7;
  -ms-grid-column-span: 5;
  grid-column: 7/12;
  overflow: hidden;
}

#img_box2 {
  overflow: hidden;
  -ms-grid-row: 2;
  -ms-grid-row-span: 1;
  grid-row: 2/3;
  -ms-grid-column: 7;
  -ms-grid-column-span: 5;
  grid-column: 7/12;
}

.text1 {
  word-spacing: 5px;
  line-height: 40px;
}

#together1_text {
  word-spacing: 7px;
  line-height: 40px;
  -ms-grid-column: 2;
  -ms-grid-column-span: 4;
  grid-column: 2/6;
  -ms-grid-row: 1;
  -ms-grid-row-span: 2;
  grid-row: 1/3;
}

#together1 {
  width: 40vw;
}

#together1:hover {
  -webkit-transform: scale(1.1);
          transform: scale(1.1);
  -webkit-transition: ease-in-out 0.5s;
  transition: ease-in-out 0.5s;
}

#together2 {
  width: 40vw;
}

#together2:hover {
  -webkit-transform: scale(1.1);
          transform: scale(1.1);
  -webkit-transition: ease-in-out 0.5s;
  transition: ease-in-out 0.5s;
}

#together2_text {
  display: -ms-grid;
  display: grid;
  -ms-grid-column: 2;
  -ms-grid-column-span: 7;
  grid-column: 2/9;
  -ms-grid-row: 3;
  -ms-grid-row-span: 1;
  grid-row: 3/4;
}

#center_ul {
  margin-left: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}

#ul_url {
  color: #0f475e;
  font-size: 28px;
}
.text1 {
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  text-align: justify;
  font-size: 18px;
}


.line {
  width: 100%;
  height: 50px;
  background: #A80315;
  -webkit-box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.4);
          box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.4);
}

#myline {
  margin-top: 100px;
}


@media only screen and (max-width: 414px) {
  .text1 {
    word-spacing: 2px;
    line-height: 20px;
    margin-bottom: 40px;
    font-size: 10px;
  }
  .break {
    display: none;
  }
  .center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
  #myline {
    margin-top: 60px;
  }
  .first_news {
    padding-top: 60px;
    padding-bottom: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
  #together1_text {
    width: 80%;
    font-family: Arial;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16 px;
    text-align: justify;
  }
  #together1 {
    margin-top: 40px;
    width: 80vw;
    margin-bottom: 10px;
  }
  #together1:hover {
    -webkit-transform: none;
            transform: none;
  }
  #together2 {
    margin-top: 10px;
    width: 80vw;
    margin-bottom: 40px;
  }
  #together2:hover {
    -webkit-transform: none;
            transform: none;
  }
  #center_ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }
  #ul_url {
    color: #0f475e;
    font-size: 14px;
  }
}

@media only screen and (max-width: 768px) and (min-width: 414px) {
  .text1 {
    word-spacing: 2px;
    line-height: 20px;
    margin-bottom: 40px;
    font-size: 10px;
  }
  .break {
    display: none;
  }
  .center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
  #myline {
    margin-top: 60px;
  }
  .first_news {
    padding-top: 60px;
    padding-bottom: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
  #together1_text {
    width: 80%;
    font-family: Arial;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16 px;
    text-align: justify;
  }
  #together1 {
    margin-top: 40px;
    width: 80vw;
    margin-bottom: 10px;
  }
  #together1:hover {
    -webkit-transform: none;
            transform: none;
  }
  #together2 {
    margin-top: 10px;
    width: 80vw;
    margin-bottom: 40px;
  }
  #together2:hover {
    -webkit-transform: none;
            transform: none;
  }
  #center_ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }
  #ul_url {
    color: #0f475e;
    font-size: 14px;
  }
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .text1 {
    word-spacing: 2px;
    line-height: 20px;
    margin-bottom: 40px;
    font-size: 14px;
  }
  .break {
    display: none;
  }
  .center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
  #myline {
    margin-top: 60px;
  }
  .first_news {
    padding-top: 60px;
    padding-bottom: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
  #together1_text {
    width: 80%;
    font-family: Arial;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16 px;
    text-align: justify;
  }
  #together1 {
    margin-top: 40px;
    width: 80vw;
    margin-bottom: 10px;
  }
  #together1:hover {
    -webkit-transform: none;
            transform: none;
  }
  #together2 {
    margin-top: 10px;
    width: 80vw;
    margin-bottom: 40px;
  }
  #together2:hover {
    -webkit-transform: none;
            transform: none;
  }
  #center_ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }
  #ul_url {
    color: #0f475e;
    font-size: 14px;
  }
}



</style>
